module.exports = __webpack_public_path__ + "img/import_open.75cc38b.png";